import $ from "jquery";
import { useCallback } from "react";
import { loadFastModeContent } from "../../others/fastModeContent.js";
import { useStores } from "../../store/rootStore.js";
import { TreeStore } from "../../store/treeStore.js";
import { addUrlParam } from "../../utils/addUrlParam.js";
import { urlParam } from "../../utils/urlParam.js";
/**
 * A node gets selected. Depending on the fast mode the page gets reloaded
 * or the wp list table gets reloaded.
 */ function useHandleSelect(toolbarActiveButton, isOrderModeActive, fastModeContentLoaded) {
    const { optionStore, treeStore } = useStores();
    const handleSelect = useCallback(async (id)=>{
        const { others: { typenow, screenSettings: { isFastMode } } } = optionStore;
        // If sorting no action is allowed and not already selected
        if (toolbarActiveButton === "sort") {
            return;
        }
        // Generate URL with query args
        let url = window.location.href;
        if (id === TreeStore.ID_ALL) {
            url = addUrlParam(window.location.pathname, "post_type", typenow);
        } else {
            const node = treeStore.byId(+id);
            $.each(node.properties.queryArgs, (key, value)=>{
                url = addUrlParam(url, key, value);
            });
        }
        +urlParam("paged") > 1 && (url = addUrlParam(url, "paged", 1));
        // Update busy state for selected item
        const node = id === TreeStore.ID_ALL ? treeStore.byId(TreeStore.ID_ALL, false) : treeStore.byId(id, false);
        if (node) {
            treeStore.setSelected(node);
        }
        if (isFastMode && !isOrderModeActive) {
            // Fast mode active so load URL and get content
            node?.setBusy(false);
            const resolvedId = id === TreeStore.ID_ALL ? TreeStore.ID_ALL : id;
            const reselectNode = ()=>treeStore.setSelected(treeStore.byId(resolvedId, false));
            reselectNode();
            setTimeout(()=>loadFastModeContent(url).then(()=>{
                    fastModeContentLoaded?.();
                    reselectNode();
                }));
        } else {
            window.location.href = url;
            node?.setBusy(true);
        }
    }, [
        toolbarActiveButton,
        isOrderModeActive,
        optionStore,
        treeStore,
        fastModeContentLoaded
    ]);
    return handleSelect;
}
export { useHandleSelect };
